//ユーザーナビゲーション
export class Navigation {
    navigation;
    btn_map;
    map;
    btn_menu;
    btn_menu_close;
    menu;
    btn_home;
    welcome;
    btn_welcome;
    btn_welcome_close;

    constructor(HomeCallback, isShow = true, isWelcomeShow = false, isMenuShow = false, isMapShow = false) {

        //HTML要素の取得
        this.navigation = document.getElementById('navigation');
        this.btn_home = document.getElementById('btn_home');

        this.btn_welcome = document.getElementById('btn_welcome');
        this.btn_welcome_close = document.getElementById('btn_welcome_close');
        this.welcome = document.getElementById('welcome');
        this.btn_menu = document.getElementById('btn_menu');
        this.btn_menu_close = document.getElementById('btn_menu_close');
        this.menu = document.getElementById('locationmenu');
        this.btn_map = document.getElementById('btn_map');
        this.map = document.getElementById('map');

        if (this.btn_home != null) {
            this.btn_home.addEventListener("click", (e: Event) => {
                HomeCallback();
            });
        }
        if (this.btn_welcome != null) {
            this.btn_welcome.addEventListener("click", (e: Event) => {
                this.ShowWelcome();
            });
        }
        if (this.btn_welcome_close != null) {
            //console.log('btn_welcome_close');
            this.btn_welcome_close.addEventListener("click", (e: Event) => {
                this.HideWelcome();
            });
        }
        if (this.btn_menu != null) {
            this.btn_menu.addEventListener("click", (e: Event) => {
                this.ShowMenu();
            });
        }
        if (this.btn_menu_close != null) {
            this.btn_menu_close.addEventListener("click", (e: Event) => {
                this.HideMenu();
            });
        }
        if (this.btn_map != null) {
            this.btn_map.addEventListener("click", (e: Event) => {
                this.ToggleMap();
            });
        }

        if (isShow) {
            this.Show();
        } else {
            this.Hide();
        }
        if (isWelcomeShow) {
            this.ShowWelcome();
        } else {
            this.HideWelcome();
        }
        if (isMenuShow) {
            this.ShowMenu();
        } else {
            this.HideMenu();
        }
        if (isMapShow) {
            this.ShowMap();
        } else {
            this.HideMap();
        }
    }

    // navigation表示
    Show() {
        if (this.navigation != null) {
            this.navigation.style.display = 'block';
        }

    }
    // navigation非表示
    Hide() {
        if (this.navigation != null) {
            this.navigation.style.display = 'none';
        }
    }

    // welcomeの表示・非表示
    ShowWelcome(){
        if(this.welcome != null  && (this.menu != null && this.menu.style.display == 'none')) this.welcome.style.display = 'block';
    }
    HideWelcome(){
        console.log('HideWelcome');
        if(this.welcome != null) this.welcome.style.display = 'none';
    }
    ToggleWelcome() {
        if (this.welcome != null) {
            if (this.welcome.style.display == 'none') {
                this.ShowWelcome();
            } else {
               this.HideWelcome();
            }
        }
    }
    // menuの表示・非表示
    ShowMenu(){
        if(this.menu != null && (this.welcome != null && this.welcome.style.display == 'none')) this.menu.style.display = 'block';
    }
    HideMenu(){
        if(this.menu != null) this.menu.style.display = 'none';
    }
    ToggleMenu() {
        if (this.menu != null) {
            if (this.menu.style.display == 'none') {
                this.ShowMenu();
            } else {
               this.HideMenu();
            }
        }
    }
    // mapの表示・非表示
    ShowMap(){
        if(this.map != null) this.map.style.display = 'block';
    }
    HideMap(){
        if(this.map != null) this.map.style.display = 'none';
    }
    ToggleMap() {
        if (this.map != null) {
            if (this.map.style.display == 'none') {
                this.ShowMap();
            } else {
                this.HideMap();
            }
        }
    }


    //アピアランスの変更
    reset() {
        this.btn_home.style.display = 'block';
        this.menu.style.display = 'none';
        this.map.style.display = 'none';
    }
}